exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-survey-create-survey-sent-success-styles__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n}\n\n.src-client-survey-create-survey-sent-success-styles__container > * {\n  padding: 8px;\n}\n\n.src-client-survey-create-survey-sent-success-styles__readyToSend {\n  font-size: 24px;\n}\n\n.src-client-survey-create-survey-sent-success-styles__circle {\n  stroke: var(--cps-color-primary);\n}\n\n.src-client-survey-create-survey-sent-success-styles__triangle {\n  fill: var(--cps-color-primary);\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-client-survey-create-survey-sent-success-styles__container",
	"readyToSend": "src-client-survey-create-survey-sent-success-styles__readyToSend",
	"circle": "src-client-survey-create-survey-sent-success-styles__circle",
	"triangle": "src-client-survey-create-survey-sent-success-styles__triangle"
};